import { render } from "./Loader.vue?vue&type=template&id=72abc068&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=72abc068&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72abc068"]])

export default __exports__